import {StateWithUsersState} from '../store';
import {User} from './reducer';

export type UserInfo = User;

export const getUsersInfo = (state: StateWithUsersState): DictionaryOf<UserInfo> => state.users;
